import { Injectable } from "@angular/core";
import {
  NavigationExtras,
  Router
} from "@angular/router";
import { NavigationService } from "./navigation.service";
import { ProjectService } from "./project.service";

export interface Header {
  /**
   * The domain of header
   */
  domain?: string;
  /**
   * The left-side breadcrumb of header
   */
  leftBreadcrumb?: string[];
  /**
   * The right-side breadcrumb of header
   */
  rightBreadcrumb?: string[];
  /**
   * The header icon setup
   */
  headerIcon?: HeaderIcon;
  /**
   * The header action button setup
   */
  headerButton?: HeaderButton[];
  /**
   * The header button step setup
   */
  headerStep?: HeaderStep;
  /**
   * Disable show project selected
   */
  disableProject?: boolean;
  /**
   * The header project setup
   */
  project?: HeaderProject;
}
export interface HeaderIcon {
  /**
   * The icon of the header and please refer to
   * https://material.io/resources/icons/?style=baseline and is optional by default will back icon
   */
  icon?: string;
  /**
   * The action want to perform by default is back to pervious page
   */
  action?: HeaderAction;
}
export interface HeaderAction {
  /**
   * Which url will want to go but no have any default value
   */
  url?: string;
  /**
   * parameters will want to pass to other page thought query params string and is optional but no have any default value
   */
  parms?: {};
  /**
   * Call back function and is optional but no have any default value
   */
  function?: Function;
}
export interface HeaderButton {
  /**
   * The title of the button and no have any default value
   */
  title?: string;
  /**
   * The icon of the button and no have any default value
   */
  icon?: string;
  /**
   * To determine the button is show out or keep inside the menu and by default is show out the menu in header
   */
  isMenu?: boolean;
  /**
   * The action want to perform and no default value
   */
  action?: HeaderAction;
  /**
   * The class of the button and is optional
   */
  butttonClass?: string;
  /**
   * The class of the icon button and is optional
   */
  iconClass?: string;
}
export interface HeaderStep {
  /**
   * The total step
   */
  total: number;
  /**
   * The current step
   */
  current?: number;
}

export interface HeaderProject {
  /**
   * Selected project Id
   */
  projectId?: string;
  /**
   * Call back function and is optional but no have any default value
   */
  function?: Function;
  /**
   * To determine want to enable the switch project function or not and by default is enable
   */
  disableSwitchProject?: boolean;
}

/**
 * @Purpose Header Management
 * @LastUpdate d 27 March 2020
 */
@Injectable()
export class HeaderService {
  public header: Header;

  constructor(
    private router: Router,
    private projectService: ProjectService,
    private navigationService: NavigationService
  ) {}

  public callBackFunction(action: HeaderAction, isButton: boolean = false) {
    if (!action && !isButton) {
      this.navigationService.backPerviousPage();
      return;
    }
    if (action.function) {
      action.function();
    }
    if (action.url) {
      let navigationExtras: NavigationExtras = {
        queryParams: action.parms || {},
      };
      this.router.navigate([action.url], navigationExtras);
    }
  }

  public getButton(): HeaderButton[] {
    if (!this.header.headerButton || this.header.headerButton.length == 0)
      return [];
    return this.header.headerButton.filter((x) => !x.isMenu);
  }

  public getMenu(): HeaderButton[] {
    if (!this.header.headerButton) return [];
    return this.header.headerButton.filter((x) => x.isMenu);
  }

  public getProjectId(): string {
    if (!this.header.project)
      this.header.project = {
        projectId: this.projectService.GetLocalStorageProjectId(),
        disableSwitchProject: true,
      };
    else if (!this.header.project.projectId) {
      let localStorageProjectId = this.projectService.GetLocalStorageProjectId();
      if (!localStorageProjectId) {
        let projectList = this.projectService.GetAllProjects();
        if (projectList && projectList.length > 0)
          this.header.project.projectId = projectList[0].project_id;
      } else
        this.header.project.projectId = this.projectService.GetLocalStorageProjectId();
    }
    return this.header.project.projectId;
  }
}
